<div class="modal-header">
    <h4 *ngIf="edit" class="modal-title" id="mondalAddCampaignTitle">Editar diagramacion</h4>
    <h4 *ngIf="!edit" class="modal-title" id="mondalAddCampaignTitle">Diagramar</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">       
        <mat-divider></mat-divider>
        <div>
            <mat-horizontal-stepper [linear]="false" #stepper>
                <!-- Paso 1 -->
                <mat-step [stepControl]="firstFormGroup">
                  <form [formGroup]="firstFormGroup">
                    <ng-template matStepLabel>Selección POP</ng-template>
                    <!--<mat-form-field>
                      <mat-label>Campo 1</mat-label>
                      <input matInput formControlName="medio" required>
                      <mat-error *ngIf="firstFormGroup.get('medio')?.hasError('required')">
                        Este campo es obligatorio
                      </mat-error>
                    </mat-form-field>-->
                    <div class="row step-container">
                        <div class="col-sm-3"> 
                            <div class="row">
                                    <mat-form-field appearance="outline">
                                      <mat-label>Alias</mat-label>
                                      <input matInput formControlName="alias" maxlength="255" name="alias">
                                    </mat-form-field>

                                    <app-generic-autocomplete
                                        [dataSource]="filteredMedios"
                                        formControlName="medio"
                                        (selectedValueChange)="medioSelected($event)"
                                        [disabled]="edit"
                                        placeholder="Medio"
                                        displayField="nombre">
                                    </app-generic-autocomplete>
                                    <div style="margin-top: -18px">
                                       <mat-error  *ngIf="firstFormGroup.get('medio')?.hasError('required') && firstFormGroup.get('medio')?.touched">El medio es requerido.</mat-error>
                                    </div>

 
                                    <app-generic-autocomplete
                                        [dataSource]="elementos"
                                        formControlName="elemento_pop"
                                        (selectedValueChange)="popSelected($event)"
                                        [disabled]="(firstFormGroup.get('medio')?.value == null || firstFormGroup.get('medio')?.value == '') || edit"
                                        placeholder="Elemento POP"
                                        displayField="nombre">
                                    </app-generic-autocomplete>
                                    <div style="margin-top: -18px">
                                      <mat-error *ngIf="firstFormGroup.get('elemento_pop')?.hasError('required') && firstFormGroup.get('elemento_pop')?.touched">El elemento POP es requerido.</mat-error>
                                    </div>
                            

                                    <!--<ng-container *ngIf="edit">
                                      <mat-form-field appearance="outline" class="form-field" [hidden]="!hasPositions">
                                        <mat-label>Posición</mat-label>
                                        <input type="number" [min]="min_pos" [max]="max_pos" [readonly]="edit" (change)="positionSelected($event)"  matInput formControlName="position"  required>
                                        <mat-error *ngIf="firstFormGroup.get('position')?.hasError('required')">
                                          Este campo es obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                    </ng-container>-->
                                   <!-- -->
                                    <ng-container >
                                       <mat-form-field appearance="outline" class="form-field" [hidden]="!hasPositions">
                                        <mat-label>Posición</mat-label>
                                        <mat-select (selectionChange)="positionSelected($event);"  matInput formControlName="position" required name="position">
                                          <mat-option *ngFor="let pos of posList" [value]="pos">{{ pos }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="firstFormGroup.get('position')?.hasError('required')">
                                          Este campo es obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                    </ng-container>

                                    <mat-form-field appearance="outline">
                                      <mat-label>Descripción del Medio</mat-label>
                                      <textarea matInput style="color:black" [value]="getMedioDescripcion()" rows="2" disabled></textarea>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                      <mat-label>Comentarios</mat-label>
                                      <textarea matInput formControlName="comentarios" rows="2" name="comentarios"></textarea>
                                    </mat-form-field>
                                    <mat-slide-toggle formControlName="imprime">Se imprime</mat-slide-toggle>

                                    <div class="row align-items-center mb-2">
                                        <div class="d-flex align-items-center">
                                            <mat-label class="me-2">Archivos</mat-label>
                                            <button *ngIf="images.length > 0" mat-raised-button color="primary" class="btn-small" matTooltip="Ver archivos" (click)="verImagenes(curr_diagram)">
                                                <mat-icon>image</mat-icon>
                                            </button>
                                            <button type="button" mat-stroked-button color="accent" class="ms-2" (click)="fileUpload.click()">Subir</button>
                                            <span *ngIf="selectedFiles.length > 0" class="ms-2">{{selectedFiles.length}} archivo(s) seleccionado(s)</span>
                                        </div>
                                        <div class="d-none">
                                            <input id="fileUpload" #fileUpload type="file" accept="image/*,application/pdf,application/zip,.zip" multiple (change)="onFileSelected($event)"/>
                                        </div>
                                    </div>
                                   <div class="mt-2" *ngIf="edit">
                                      <button mat-raised-button color="primary" (click)="guardarDiagramaSlim()" [disabled]="selectedPromotions.length == 0">Guardar</button>
                                    </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                              <div class="selected-codes">
                                <span><b>Promociones seleccionadas:</b> <span *ngIf="selectedPromotions.length == 0">Ninguno</span> <span *ngIf="selectedPromotions.length > 0">{{ selectedPromotions.length }}</span></span>
                              
                              </div>

                                <div class="overflow-auto w-200">
                                    <div style="display: flex; align-items: center; gap: 10px;">
                                      <mat-form-field style="width: 80%;" [hidden]="">
                                        <mat-label>Selección masiva por código principal</mat-label>
                                        <input matInput [(ngModel)]="codigosPrincipalInput" placeholder="1111,2222,3333" [ngModelOptions]="{standalone: true}" > 
                                      </mat-form-field>
                                      <button mat-stroked-button (click)="takeCodigosPrincipalInput()" color="accent">Seleccionar</button>
                                      <button mat-stroked-button color="accent"  (click)="fileInputP.click()">Excel</button>
                                      <input type="file" #fileInputP (change)="onExcelSelectedProm($event)" accept=".xlsx, .xls" hidden>
                                      <button mat-stroked-button color="accent" (click)="generatePromExcel()">Descargar</button>
                                </div>

                                </div>
                              <div class="overflow-auto w-200">
                                  <mat-form-field appearance="outline" class="form-field same-height col-visibles">
                                       <mat-label>
                                        <mat-spinner *ngIf="loadingPromColumns" [diameter]="15" style="display: inline-block; margin-left: 5px; vertical-align: middle; margin-top: -4px"></mat-spinner>
                                           Columnas visibles de promociones
                                       </mat-label>
                                       <mat-select
                                           [(ngModel)]="selectedColumns"
                                           [ngModelOptions]="{standalone: true}"
                                           (openedChange)="onSelectOpenedChanged($event)"
                                           (selectionChange)="updateColumnas()"
                                           multiple
                                       >
                                           <mat-option class="action-option no-checkbox" (click)="toggleSelectAllColumns(selectedColumns)" [disabled]="true">
                                           <mat-icon>library_add</mat-icon> Seleccionar/Quitar todas las columnas
                                           </mat-option>
                                           <mat-option *ngFor="let u of columnsProm" [value]="u">
                                           {{ u }}
                                           </mat-option>
                                       </mat-select>
                                   </mat-form-field>
                                <!--<mat-form-field>
                                    <mat-label>
                                        <mat-icon>search</mat-icon> Buscar</mat-label>
                                    <input matInput (keyup)="applyFilter($event, dspromotionFile)" placeholder="Dangler" #input>
                                </mat-form-field>-->
                              <!--<mat-form-field>
                                  <mat-label>
                                      <mat-icon>numbers</mat-icon>Código</mat-label>
                                  <input matInput placeholder="8122121112" name="codigoFilter" [(ngModel)]="codigoFilter">
                              </mat-form-field>-->
                              <!--<mat-form-field>
                                <mat-label> <mat-icon>world</mat-icon> Mundo</mat-label>
                                <mat-select  matInput name="mundo">
                                  <mat-option *ngFor="let m of mundosList" [value]="m">{{ m }}</mat-option>
                                </mat-select>
                              </mat-form-field>-->
                                <mat-form-field appearance="outline" class="mb-0 ms-4 custom-search-field filters-diag">
                                  <mat-icon matPrefix>search</mat-icon>
                                  <input matInput placeholder="Buscar..." (keyup)="applyGlobalFilter($event)" >
                                </mat-form-field>
                                <mat-slide-toggle class="ms-4" (change)="toggleSeleccionados($event)">Ver solo promociones seleccionadas</mat-slide-toggle>
                            </div>
                              <div class="promo-container mat-elevation-z0 table-responsive text-nowrap" style="max-height: 55vh; overflow-y: auto; padding: 10px; border: 1px solid #ccc;">
                                <div *ngIf="loadingPromotions" class="promo-table-loading">
                                  <mat-spinner diameter="40"></mat-spinner>
                                  <span class="ms-2">Cargando promociones...</span>
                                </div>

                                <table *ngIf="!loadingPromotions" mat-table [dataSource]="dspromotionFile" matSort #sort="matSort" class="mat-elevation-z8" style="width: 100%;">
                                  
                                  <!-- Checkbox para seleccionar todos -->
                                  <ng-container matColumnDef="select">
                                    <th class="text-center do-jump-line-make-bonito" mat-header-cell *matHeaderCellDef sticky style="min-width: 80px; margin-left: 14px;"> 
                                      <input type="checkbox"  [checked]="selectAllValue" (click)="doSelectAllValue()" (change)="selectAll($event)">
                                    </th>
                                    <td  class="text-center" mat-cell sticky *matCellDef="let promo" style="min-width: 80px; margin-left: 14px;">
                                      <input type="checkbox" (change)="toggleSelection(promo['CODIGO PRINCIPAL'])" [checked]="selectedPromotions.includes(promo['CODIGO PRINCIPAL'])">
                                    </td>
                                  </ng-container>
                              
                                  
                                  <ng-container *ngFor="let column of displayedColumns">
                                    <ng-container matColumnDef="{{column}}">
                                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="custom-header" style="min-width: 190px;">
                                        <div class="header-wrapper">
                                          <div class="header-title">{{ column }} </div> 
                                          <mat-form-field appearance="outline" class="filter-input" (click)="$event.stopPropagation()">
                                            <mat-label><mat-icon>search</mat-icon></mat-label>
                                            <input matInput (keyup)="applyColumnFilterPromo(column, $event)">
                                          </mat-form-field>
                                        </div>
                                      </th>
                                      <td mat-cell *matCellDef="let promo"  style="min-width: 170px; margin-left: 14px;" [ngClass]="{'has-pending-request': getChange(promo.solicitud, column)}"> 
                                            <ng-container>
                                                <div class="">
                                                    <ng-container *ngIf="getChange(promo.solicitud, column) as change; else normalValue">
                                                        <span class="pending-change">{{ change.valor_nuevo }}</span> 
                                                    </ng-container>
                                                    <ng-template #normalValue>
                                                        {{ promo[column.trim()] }} 
                                                    </ng-template>
                                                </div>
                                                <div *ngIf="getChange(promo.solicitud, column) as change;" class="edited-cell-original">
                                                    {{ change.valor_actual }}
                                                </div>
                                            </ng-container>
                                        </td>
                                    </ng-container>
                                  </ng-container>
                              
                                  <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
                                  <tr mat-row *matRowDef="let row; columns: allColumns;" [ngClass]="getRowClass(row)"></tr>
                                </table>
                                <div *ngIf="!loadingPromotions && dspromotionFile?.data?.length === 0" class="promo-empty-state">
                                  No hay promociones disponibles.
                                </div>
                                <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
                              </div>
                        </div>
                    </div>
                    <div *ngIf="loaded" class="modal-footer">
                     <!-- <button (click)="debugform()">validar</button>-->
                          <button mat-raised-button matStepperNext color="primary" [disabled]="(!(firstFormGroup.valid)||selectedPromotions.length==0)" (click)="setSecondData()">Siguiente</button>
                    </div>
                  </form>
                </mat-step>

                <mat-step>
                  <ng-template matStepLabel>VoBos</ng-template>
                            <div class="row step-container mb-1">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <mat-form-field class="sel-plant" appearance="outline">
                                      <mat-label>Seleccionar plantilla</mat-label>
                                      <mat-select [(ngModel)]="plantillaSeleccionada" (selectionChange)="cargaVobosPlantilla($event.value)">
                                        <mat-option *ngFor="let plantilla of plantillas" [value]="plantilla.id">
                                          {{plantilla.nombre}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-sm-6 text-end">
                                  
                                    <button (click)="goToConfig()" mat-flat-button color="primary" class="same-height me-2" style="width: 190px;">
                                      <mat-icon>edit</mat-icon> Configuración VoBos
                                    </button>
                                  
                                    <button [disabled]="!selectedVobos" (click)="openModalAddPlantilla()" mat-flat-button color="primary" class="same-height me-2">
                                      <mat-icon>add</mat-icon> Agregar plantilla
                                    </button>
                                  
                                    <button mat-flat-button color="primary" [matMenuTriggerFor]="menuP" class="same-height" [disabled]="id_plantSel == 0">
                                      <mat-icon>settings</mat-icon>
                                    </button>
                                    <mat-menu #menuP="matMenu">
                                      <button mat-menu-item (click)="actualizarPlantilla()">
                                        <mat-icon>update</mat-icon>
                                        <span>Actualizar plantilla</span>
                                      </button>
                                      <button mat-menu-item (click)="eliminarPlantilla()">
                                        <mat-icon>delete</mat-icon>
                                        <span>Eliminar plantilla</span>
                                      </button>
                                    </mat-menu>
                                  
                                  
                                  </div>
                                </div>
                                <div *ngIf="alertEditPlantilla" class="row mt-2" style="background-color: #FEE9B8; border-radius: 20px 20px 20px 20px; margin-left: 0.7rem; margin-right: 2rem">
                                  <div class="col-sm-12 d-flex align-items-center pt-2 pb-2" style="color:#9c7b2f" >
                                    <mat-icon class="me-3" >
                                      info
                                    </mat-icon>
                                    Plantilla actualizada. Puedes usar los botones de acción para guardarla como nueva o actualizarla.
                                  </div>
                                </div>
                                <div class="row mt-3 mb-1">
                                  <div class="col-sm-10">
                                    <h4>Fases Configuradas: {{totalPhasesConfiguradas}}/{{phases.length}}</h4>
                                  </div> 
                                </div>
                              <mat-divider></mat-divider>
                              <div *ngIf="secondDataLoaded" class="horizontal-scroll pt-0 mt-3">
                                <div class="phase-card" *ngFor="let phase of phases" style="padding-top: 0px !important">
                                  <mat-card class="phase-card-content">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <mat-card-title>{{ phase.name }}</mat-card-title>
                                      <span class="badge rounded-pill text-dark fs-6" [ngClass]="{
                                          'bg-custom-green': phase.totalVobosSelected === phase.vobos.length,
                                          'bg-custom-yellow': phase.totalVobosSelected !== phase.vobos.length
                                        }">{{phase.totalVobosSelected == undefined ? 0 : phase.totalVobosSelected}}/{{phase.vobos.length}}</span>
                                    </div>
                                   
                                    <div class="vobo-scroll-area">
                                      <div class="vobo-list" *ngFor="let item of phase.vobos; let i = index">
                                        <div class="vobo-title"><b>{{ item.area }}</b></div>
                                        <!--<div mat-line>Usuarios totales: {{ item.users?.length }}</div>-->
                                        <div *ngIf="item.optional == 1"><b>Opcional</b></div>
                                        <mat-form-field
                                         appearance="fill" class="compact-field">
                                          <mat-label *ngIf="item.selectedUsers.length == 0">Sin responsables</mat-label>
                                           <mat-label *ngIf="item.selectedUsers.length != 0">Responsables seleccionados</mat-label>
                                          <mat-select [(ngModel)]="item.selectedUsers"
                                            (selectionChange)="onUserSelectionChange(phase.id)"  (closed)="clearSearch(item)" (openedChange)="onSelectOpened(i)" #selectRef multiple>
                                                <div class="search-option" >
                                                 <div class="search-input-container mat-form-field-outlined">
                                                  <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                                                  <input
                                                    #searchInput
                                                    type="text"
                                                    [(ngModel)]="item.searchTerm"
                                                    (ngModelChange)="filterUsers(item)"
                                                    (click)="$event.stopPropagation()"
                                                    matInput
                                                  />                               
                                                 </div><button mat-button (click)="toggleSelectAllUsers(item, phase.id)"><mat-icon>library_add</mat-icon>Seleccionar/Quitar todos</button>
                                                </div>
                                            <mat-option *ngFor="let u of item.filteredUsers" [value]="u.id">{{ u.name }}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                  </mat-card>
                                </div>
                              </div>
                            </div>

                      <div *ngIf="loaded" class="modal-footer mt-5">
                         <button mat-button matStepperPrevious>Regresar</button>
                        
                         <button mat-raised-button matStepperNext color="primary" [disabled]="!selectedVobos">Siguiente</button>
                     </div>

                </mat-step>
              
                <!-- Paso 2 -->
                <mat-step [stepControl]="secondFormGroup">
                  <form [formGroup]="secondFormGroup">
                    <ng-template matStepLabel>Sucursales</ng-template>

                    <div class="row step-container">
                       <!-- <div class="col-sm-3">
                            <div class="row  text-center">
                                <button (click)="goToConfig()" mat-flat-button color="primary" class="same-height" style="width: 190px;">
                                    <mat-icon>edit</mat-icon>  Configuración VoBos
                                 </button>
                            </div>
                            <br>
                            <table class="table table-hover">
                                <thead>
                                  <tr>
                                    <th class="text-center" scope="col">Fases Configuradas</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <ng-container *ngFor="let ph of phases">
                                    <tr>
                                      <td>{{ph.name}} 
                                        <p *ngIf="!ph.selected" (click)="openVobosDiagramConfigDialog(ph)" class="badge badge-info"  data-toggle="tooltip" data-placement="right" matTooltip="Selecciona los usuarios para el vobo por area." title="Cantidad de Vobos">Selecciona usuarios</p>
                                        <p *ngIf="ph.selected" (click)="openVobosDiagramConfigDialog(ph)" class="badge badge-success"  data-toggle="tooltip" data-placement="right" matTooltip="Edita los usuarios seleccionados para el vobo por area." title="Cantidad de Vobos">Edita usuarios</p>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </tbody>
                            </table>
                            <div>
                              <button mat-button matStepperPrevious>Anterior</button>
                              --<button mat-raised-button color="primary" (click)="guardarDiagrama()" [disabled]="this.stores_sel.length==0||vobos_sel.length!=phases.length || guardandoDiagrama" ><mat-icon>save</mat-icon> Finalizar y guardar</button>--
                              <button mat-raised-button matStepperNext color="primary" [disabled]="this.stores_sel.length==0||vobos_sel.length!=phases.length">Siguiente</button>
                            </div>


                        </div>-->
                        <div class="col-sm-12">
                    
                               <!-- sucursales part -->
                                <br>
                                <div class="selected-codes">
                                    <span><b>Sucursales seleccionadas: </b> <span *ngIf="selectedStores.length == 0">Ninguna</span> <span *ngIf="selectedStores.length > 0">{{ selectedStores.length }}</span></span>
                                </div>

                                <div class="overflow-auto w-200">
                                    <div style="display: flex; align-items: center; gap: 10px;">
                                      <mat-form-field style="width: 80%;" [hidden]="(same_stores||!segmentable||edit)">
                                        <mat-label>
                                            Selección masiva por FarmIDs</mat-label>
                                        <input matInput [(ngModel)]="farmidsInput" placeholder="1111,2222,3333" [ngModelOptions]="{standalone: true}" > 
                                      </mat-form-field>
                                      <button mat-button (click)="takeFarmIdsInput()" [hidden]="(same_stores||!segmentable||edit)" color="accent">Seleccionar</button>
                                     
                                      <button mat-button color="accent" [hidden]="(same_stores||!segmentable||edit)" (click)="fileInput.click()">Excel</button>
                                      <input type="file" #fileInput (change)="onExcelSelected($event)" accept=".xlsx, .xls" hidden>

                                      <button mat-button color="accent" (click)="generateSucExcel()">Descargar</button>
                                </div>

                                </div>

                                <div class="promo-container mat-elevation-z0 table-responsive text-nowrap" style="max-height: 55vh; overflow-y: auto; padding: 10px;  padding-bottom: 20px; border: 1px solid #ccc;">
                                  <div *ngIf="loadingStores" class="promo-table-loading">
                                    <mat-spinner diameter="40"></mat-spinner>
                                    <span class="ms-2">Cargando sucursales...</span>
                                  </div>

                                  <table *ngIf="!loadingStores" mat-table [dataSource]="dsstoreFile" matSort #sortSuc="matSort" class="" style="width: 100%; padding-bottom: 30px;">
                                      
                                      <!-- Checkbox para seleccionar todos -->
                                      <ng-container matColumnDef="select">
                                        <th class="text-center" mat-header-cell *matHeaderCellDef sticky style="min-width: 80px; margin-left: 14px;"> 
                                          <ng-container *ngIf="!edit">
                                            <input type="checkbox" [checked]="toggleValue" (click)="doToggleValue()" [hidden]="(same_stores||!segmentable)&&!edit" (change)="toggleSelectionStore(0, $event)">
                                          </ng-container>

                                        </th>
                                        <td class="text-center" mat-cell *matCellDef="let store" style="min-width: 80px; margin-left: 14px;">
                                          <ng-container *ngIf="!edit">
                                             <input type="checkbox" [hidden]="(same_stores||!segmentable)&&!edit" (change)="toggleSelectionStore(store['id'], null)" [checked]="selectedStores.includes(store['id'])">
                                          </ng-container>
                                        </td>
                                      </ng-container>
                                  
                                  
                                      <ng-container *ngFor="let column of displayedColumnsStore">
                                        <ng-container matColumnDef="{{column}}">
                                          <th mat-header-cell *matHeaderCellDef class="do-jump-line-make-bonito" sticky style="min-width: 80px; height: 15px; margin-left: 14px;"> <span style="display:block; height: 33px;">{{ column }} </span> 
                                            <mat-form-field appearance="outline" class="filter-input">
                                              <mat-label><mat-icon>search</mat-icon></mat-label>
                                               <input *ngIf="column != 'Plaza'" matInput (keyup)="applyColumnFilterStores(column, $event)">

                                               <mat-select *ngIf="column === 'Plaza'" (selectionChange)="applyColumnFilterStoresSelect(column, $event.value);" matInput name="plaza">
                                                <mat-option [value]="''">Todas</mat-option>
                                                <mat-option *ngFor="let p of plazasList" [value]="p">{{ p }}</mat-option>
                                               </mat-select>
                                              </mat-form-field>
                                          </th>
                                          <td mat-cell *matCellDef="let store"  style="min-width: 80px; margin-left: 14px;"> {{ store[column] }} </td>
                                        </ng-container>
                                      </ng-container>
                                  
                                      <tr mat-header-row *matHeaderRowDef="allColumnsStore"></tr>
                                      <tr mat-row *matRowDef="let row; columns: allColumnsStore;"></tr>
                                    </table>
                                    <div *ngIf="!loadingStores && dsstoreFile?.data?.length === 0" class="promo-empty-state">
                                      No hay sucursales disponibles.
                                    </div>
                                    <mat-paginator #paginatorSuc [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
                                  </div>
                               <!--end sucursales part-->

                        </div>
                    </div>
                      <div *ngIf="loaded" class="modal-footer">
                         <button mat-button matStepperPrevious>Regresar</button>

                        <button mat-raised-button matStepperNext (click)="initializeTotalPrices();" color="primary" [disabled]="this.stores_sel.length==0||vobos_sel.length!=phases.length">Siguiente</button>
                     </div>

                  </form>
                </mat-step>
                <mat-step > 
                     <ng-template matStepLabel>Inventarios</ng-template>
                      <div class="row step-container">
                        <div style="max-height: 65vh; overflow-y: auto; overflow-x: hidden; padding: 10px; padding-bottom: 20px;">
                           <div class="col-sm-12">
                            <div class="row">
                              <ng-container>
                                    <!--POP por posicioón-->
                                <table class="table">
                                <thead>
                                  <tr class="text-center">
                                    <th scope="col">Material</th>
                                    <th scope="col">Posición</th>
                                    <th scope="col">Max. Posiciones</th>
                                    <th scope="col">Unidades totales</th>
                                    <th scope="col">Unidades disponibles</th>
                                    <th scope="col">Unidades selecionadas</th>
                                    <th scope="col">Precio</th>
                                    <th scope="col">Precio total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <ng-container *ngFor="let material of dataPositions" class="text-center">
                                    <tr [ngClass]="{ 'material-resaltado': material.id_diagrama === 0, 'no-diagramado': material.diagramado === false }">
                                      <td class="text-center">
                                        <ng-container *ngIf="material.diagramado; else sinDiagrama">
                                          {{ material.nombre }}
                                        </ng-container>
                                        <ng-template #sinDiagrama>
                                          <em>Posición sin diagramar</em>
                                        </ng-template>
                                      </td>
                                      <td class="text-center">{{ material.posicion}}</td>
                                      <td class="text-center">{{ positionsToShow }}</td>
                                      <td class="text-center">{{ material.inventario }}</td>
                                      <td class="text-center">{{ (same_stores || edit)? inventario_disp_positions : inventario_disp_positions - (edit? 0 : findMaterialTotal(material.id_pop_config))}}</td>
                                      <td class="text-center">{{ material.diagramado ?  ( material.id_diagrama === 0 ?  findMaterialTotal(material.id_pop_config) : material.seleccionado) :  "-"  }}</td>
                                      <td class="text-center" style="vertical-align: middle; padding : 0">
                                        <ng-container *ngIf="material.id_diagrama === 0">
                                          <mat-form-field class="mini-input no-padding-bottom" appearance="outline">
                                            <input type="number" matInput min="0" [(ngModel)]="material.precio" (input)="onIndividualPriceInput(material)" [ngModelOptions]="{standalone: true}">
                                          </mat-form-field>
                                        </ng-container> 
                                      </td>
                                      <td class="text-center" style="vertical-align: middle; padding : 0">
                                        <ng-container *ngIf="material.id_diagrama === 0">
                                          <mat-form-field class="med-input no-padding-bottom" appearance="outline">
                                            <input type="number" matInput min="0" [(ngModel)]="material.precioTotal" (input)="onTotalPriceInput(material)" [ngModelOptions]="{standalone: true}">
                                          </mat-form-field>
                                        </ng-container>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </tbody>
                              </table>
                    
                              </ng-container>
                            </div>
                        </div>
                        </div>

                      </div>
                      <div class="modal-footer" *ngIf="loaded">
                            <button mat-button matStepperPrevious>Regresar</button>
                            <button mat-raised-button color="primary" (click)="guardarDiagrama()" [disabled]="this.stores_sel.length==0||vobos_sel.length!=phases.length || guardandoDiagrama" ><mat-icon>save</mat-icon> Finalizar y guardar</button>
                      </div>

                </mat-step>
                <!--Paso 3-->
              </mat-horizontal-stepper>
        </div>
    </div>
</mat-dialog-content>
